/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import {
  massConfig,
  NumericDiff,
} from "components/search/input/DifferencePanel/common";
import { NameBasedObtainableBundleItem } from "store/api/generatedApi";

import { CategoryConfigFactory } from "components/search/input/DifferencePanel/common";

export const AvailableScrapItemConfigFactory: CategoryConfigFactory<
  NameBasedObtainableBundleItem
> = (utils) => {
  const { t, units, formatNumber2DPFixed } = utils;

  return {
    min_obtainable: {
      title: t("minObtainable"),
      ...massConfig(utils),
    },
    max_obtainable: {
      title: t("maxObtainable"),
      ...massConfig(utils),
    },
    specific_price: {
      title: t("price"),
      renderDiff: ({ updatedVal, previousVal }) => {
        return (
          <NumericDiff
            previous={previousVal ?? 0}
            updated={updatedVal ?? 0}
            prefix={units("cost")}
            format={formatNumber2DPFixed}
          />
        );
      },
      format: (val) => {
        if (val == null) return "N/A";
        return `${units("cost")}${formatNumber2DPFixed(val)}`;
      },
    },
    arrival_probability: {
      title: t("arrivalProbability"),
      renderDiff: ({ updatedVal, previousVal }) => {
        return (
          <NumericDiff
            previous={previousVal ?? 0}
            updated={updatedVal ?? 0}
            suffix="%"
            format={formatNumber2DPFixed}
          />
        );
      },
      format: (val) => {
        if (val == null) return "N/A";
        return `${formatNumber2DPFixed(val)}%`;
      },
    },
  };
};
